import Axios from "../../../../api/axios/Axios";

export const getCreators = async () => {
  const response = await Axios.get(`/api/creators/users`);
  return response.data;
};

export const getCreator = async ({ username }) => {
  const response = await Axios.get(`/api/creators/${username}/users`);

  return response.data;
};
